//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import { getRoom } from '../../api/room'

export default {
    name: "repairForm",
    components: { ImageUploader },
    data() {
        return {
            value: '',
            fileList: [],
            showPicker: false,
            columns: ['室内', '室外'],
            id: 0,
            owner: {},
            workOrder: {
                id: 0,
                cityId: 0,
                projectId: 0,
                content: '',
                projectName: '',
                roomNum: '',
                name: '',
                mobile: '',
                phoneNumber: '',
                repairType: 0,
                image: {
                    associateType: 'WorkOrderImage'
                }
            },
            saving: false,
            memberInfo: {},
            memberRoomType: 10
        }
    },
    methods: {
        onConfirm(value) {
            this.value = value;
            this.showPicker = false;
            if (value === '室内') {
                this.workOrder.repairType = 0
            } else if (value === '室外') {
                this.workOrder.repairType = 1
            }
        },
        // getOwnerById() {
        //     const vm = this;
        //     abp.ajax.get('/api/services/app/Owner/GetOwnerById?id=' + this.id).then(res => {
        //         vm.owner = {};
        //         vm.owner = res.data.result;
        //
        //         vm.workOrder = {};
        //
        //         vm.workOrder.content = '';
        //         vm.workOrder.id = 0;
        //
        //         vm.workOrder.cityId = this.owner.room.project.cityId;
        //         vm.workOrder.cityName = this.owner.cityName;
        //
        //         vm.workOrder.projectId = this.owner.projectId;
        //         vm.workOrder.projectName = this.owner.projectName;
        //
        //         vm.workOrder.roomId = this.owner.roomId;
        //         vm.workOrder.roomNum = this.owner.roomNumber;
        //
        //         vm.workOrder.memberId = this.owner.memberId;
        //         vm.workOrder.name = this.owner.name;
        //         vm.workOrder.mobile = this.owner.phoneNumber;
        //
        //         vm.workOrder.image = {associateType: 'WorkOrderImage'};
        //
        //     }).finally(() => {
        //         // this.loading = false;
        //     });
        // },
        onSave() {
            var vm = this;
            if (!vm.workOrder.name) {
                vm.$toast('请输入联系人');
                return
            }
            if (!vm.workOrder.mobile) {
                vm.$toast('请输入联系电话');
                return
            }
            if (vm.workOrder.repairType === undefined || vm.workOrder.repairType === null) {
                vm.$toast('请选择报修类型');
                return
            }

            if (!vm.workOrder.content) {
                vm.$toast('请输入报修描述');
                return
            }
            vm.workOrder.workOrderType = 2;
            vm.workOrder.dataSource = 2;
            ////报修人类型
            if (vm.memberRoomType == 10) {
                vm.workOrder.repairApplicantType = 0;
            } else if (vm.memberRoomType == 11) {
                vm.workOrder.repairApplicantType = 1;
            } else {
                vm.workOrder.repairApplicantType = 2;
            }
            vm.saving = true;
            this.$store.dispatch({
                type: 'workOrder/saveWorkOrder',
                data: vm.workOrder
            }).then(() => {
                vm.$toast.success('保存成功');
                // vm.$router.replace({path: '/my-repairRecords/' + vm.workOrder.memberId});
                vm.$router.replace({ path: '/my-repairRecords' });
            }).finally(() => {
                vm.saving = false;
            });
        },
        getMember() {
            const vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.memberInfo = vm.$store.state.member.memberInfo;

                vm.workOrder.memberId = vm.memberInfo.id;
                vm.workOrder.name = vm.memberInfo.name;
                vm.workOrder.mobile = vm.memberInfo.phoneNumber;

                // localStorage.setItem('MemberId', this.member.id);
            });
        },
        getRoom() {
            const vm = this;
            getRoom(this.id).then(res => {
                vm.roomInfo = {};
                vm.roomInfo = res.data.result;

                vm.workOrder.roomId = vm.roomInfo.id;

                vm.workOrder.cityId = vm.roomInfo.cityId;
                vm.workOrder.cityName = vm.roomInfo.cityName;

                vm.workOrder.projectId = vm.roomInfo.projectId;
                vm.workOrder.projectName = vm.roomInfo.projectName;
                vm.workOrder.roomNum = vm.roomInfo.roomNum;

                vm.workOrder.projectStages = vm.roomInfo.projectStages
                vm.workOrder.roomStructureName = vm.roomInfo.roomStructureName
                vm.workOrder.chamberName = vm.roomInfo.chamberName
                vm.workOrder.storeyName = vm.roomInfo.storeyName
                vm.workOrder.roomNumber = vm.roomInfo.roomNumber

            })
        }
    },
    created() {
        // this.workOrder = {
        //     content: '',
        //     projectName: '',
        //     repairType: 0,
        //     image: {
        //         associateType: 'WorkOrderImage'
        //     }
        // }
        this.getMember();
        this.id = parseInt(this.$route.params.id) || 0;
        this.memberRoomType = parseInt(this.$route.params.type) || 10;
        if (this.id > 0) {
            // this.getOwnerById();
            this.getRoom();
        }
    }
}
